import './NotFound.css';
import notFund from "../../assets/lottie/notFund.json";
import notAccess from "../../assets/lottie/notAccess.json";
import connecting from "../../assets/lottie/connecting.json"
import * as React from "react";
import {Player} from "@lottiefiles/react-lottie-player";


const ErrorPage = (
    {
        errorType = ErrorType.CONNECTING,
        title = "هیچ اطلاعاتی برای نمایش وجود ندارد!",
        subTitle = "در جستجو از عبارت های متداول تر استفاده نمایید یا تعدادی از فیلتر ها را حذف نمایید.",
        fullPage = false
    }) => {
    return (
        <section className={`${fullPage ? "not-found-container-full-page-style" : "w-100 h-100"}`}>
            <section className={`not-found-container`}>
                <Player
                    src={errorType}
                    loop
                    autoplay
                    style={{height: '200px', width: '200px'}}
                />
                <span className="not-found-title">
                    {title}
                </span>
                <span className="not-found-sub-title">
                    {subTitle}
                </span>
            </section>
        </section>

    )
}
export default ErrorPage


export const ErrorType = {
    "NOT_FOUND": notFund,
    "NOT_ACCESS": notAccess,
    "CONNECTING": connecting,
}